import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		loading: true,
		center: [108.0, 36.0],
		mapTop: "920px",
		fromDetail: false,
		mapData: {
			national: [],
			province: {},
			city: {}
		}
	},
	mutations: {
		setPageLoading(state, loading) {
			state.loading = loading;
		},
		SET_CENTER(state, center) {
			state.center = center;
		},
		SET_MAP_TOP(state, top) {
			state.mapTop = top;
		},
		SET_MAP_DATA(state, data) {
			state.mapData = data || { national: [], province: {}, city: {} };
		},
		SET_FROM_DETAIL(state, val) {
			state.fromDetail = val;
		}
	},
	actions: {
		updateMapData({ commit }, data) {
			commit("SET_MAP_DATA", data);
		}
	}
});
